/**
 * @generated SignedSource<<0a495ce3d36b945aa10053748dd9c604>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItemScheduleDaily_schedule$data = {
  readonly weekdays: ReadonlyArray<{
    readonly startTime: {
      readonly hour: number;
      readonly minute: number;
    } | null;
    readonly weekday: number;
  }>;
  readonly " $fragmentType": "WorkspaceRoutinesListItemScheduleDaily_schedule";
};
export type WorkspaceRoutinesListItemScheduleDaily_schedule$key = {
  readonly " $data"?: WorkspaceRoutinesListItemScheduleDaily_schedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemScheduleDaily_schedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItemScheduleDaily_schedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineScheduleDailyWeekday",
      "kind": "LinkedField",
      "name": "weekdays",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Time",
          "kind": "LinkedField",
          "name": "startTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hour",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minute",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleDaily",
  "abstractKey": null
};

(node as any).hash = "7e0f0d2092e7890bc93a0035df724a4f";

export default node;
